import { useQuery, keepPreviousData } from "@tanstack/react-query";
import timesheetService from "../../services/timesheetService";

interface UseMyVisitsParams {
    page?: number;
    rowsPerPage?: number;
}

const useMyVisits = ({ page = 0, rowsPerPage = 5 }: UseMyVisitsParams) =>
    useQuery({
        queryKey: ["my-visits", page, rowsPerPage],
        queryFn: () => timesheetService.fetchMyVisits({ page, rowsPerPage }),
        placeholderData: keepPreviousData,
    });

export default useMyVisits;
